import { Tabs as MuiTabs, tabsClasses as muiTabsClasses } from '@mui/material';
export const Tabs = MuiTabs;
export const tabsClasses = muiTabsClasses;
